import { Pipe, PipeTransform } from '@angular/core';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';

@Pipe({
    name: 'announcementFilter'
})
export class AnnouncementFilterPipe implements PipeTransform {
    transform(announcementDataSource: TylerMatTableDataSource, school: string): TylerMatTableDataSource {
        return new TylerMatTableDataSource(
            announcementDataSource.data.filter(x => x.SchoolName == school)
        );
    }
}
